'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _xss = require('xss');

var _xss2 = _interopRequireDefault(_xss);

var _helper = require('@appbaseio/reactivecore/lib/utils/helper');

var _remarkable = require('remarkable');

var _constants = require('@appbaseio/reactivecore/lib/utils/constants');

var _AIAnswer = require('../../../styles/AIAnswer');

var _InputWrapper = require('../../../styles/InputWrapper');

var _InputWrapper2 = _interopRequireDefault(_InputWrapper);

var _InputGroup = require('../../../styles/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _SearchSvg = require('../../shared/SearchSvg');

var _SearchSvg2 = _interopRequireDefault(_SearchSvg);

var _IconGroup = require('../../../styles/IconGroup');

var _IconGroup2 = _interopRequireDefault(_IconGroup);

var _IconWrapper = require('../../../styles/IconWrapper');

var _IconWrapper2 = _interopRequireDefault(_IconWrapper);

var _Mic = require('../addons/Mic');

var _Mic2 = _interopRequireDefault(_Mic);

var _Button = require('../../../styles/Button');

var _Button2 = _interopRequireDefault(_Button);

var _AIFeedback = require('../../shared/AIFeedback');

var _AIFeedback2 = _interopRequireDefault(_AIFeedback);

var _SearchBoxAI = require('../../../styles/SearchBoxAI');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var md = new _remarkable.Remarkable();

md.set({
	html: true,
	breaks: true,
	xhtmlOut: true,
	linkify: true,
	linkTarget: '_blank'
});

var Chat = function Chat(props) {
	var messages = props.messages,
	    onSendMessage = props.onSendMessage;

	var _React$useState = _react2.default.useState(''),
	    inputMessage = _React$useState[0],
	    setInputMessage = _React$useState[1];

	var _useState = (0, _react.useState)(null),
	    sourceDocIds = _useState[0],
	    setSourceDocIds = _useState[1];

	var _useState2 = (0, _react.useState)(null),
	    initialHits = _useState2[0],
	    setInitialHits = _useState2[1];

	var messagesContainerRef = _react2.default.useRef(null);
	var _inputRef = (0, _react.useRef)(null);
	var _inputWrapper = (0, _react.useRef)(null);
	var _errorWrapper = (0, _react.useRef)(null);

	var handleMessageInputChange = function handleMessageInputChange(e) {
		setInputMessage(e.target.value);
	};

	var handleSendMessage = function handleSendMessage(e) {
		e.preventDefault();

		if (inputMessage.trim()) {
			onSendMessage(inputMessage);
			setInputMessage('');
		}
	};
	var handleKeyPress = function handleKeyPress(e) {
		if (e.key === 'Enter') {
			handleSendMessage(e);
		}
	};
	var renderIcon = function renderIcon() {
		if (props.showIcon) {
			if (props.icon) {
				return props.icon;
			}
			if (props.iconURL) {
				return _react2.default.createElement('img', { style: { maxHeight: '25px' }, src: (0, _xss2.default)(props.iconURL), alt: 'search-icon' });
			}
			return _react2.default.createElement(_SearchSvg2.default, null);
		}
		return null;
	};

	var handleVoiceResults = function handleVoiceResults(_ref) {
		var results = _ref.results;

		if (results && results[0] && results[0].isFinal && results[0][0] && results[0][0].transcript && results[0][0].transcript.trim()) {
			onSendMessage(results[0][0].transcript.trim());
			setInputMessage('');
		}
	};
	var shouldMicRender = function shouldMicRender(showVoiceSearch) {
		// checks for SSR
		if (typeof window === 'undefined') return false;
		return showVoiceSearch && (window.webkitSpeechRecognition || window.SpeechRecognition);
	};
	var renderIcons = function renderIcons() {
		var renderMic = props.renderMic,
		    getMicInstance = props.getMicInstance,
		    showVoiceInput = props.showVoiceInput,
		    iconPosition = props.iconPosition,
		    innerClass = props.innerClass;

		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_IconGroup2.default,
				{ enableAI: true, groupPosition: 'right', positionType: 'absolute' },
				shouldMicRender(showVoiceInput) && _react2.default.createElement(_Mic2.default, {
					getInstance: getMicInstance,
					render: renderMic,
					onResult: handleVoiceResults,
					className: (0, _helper.getClassName)(innerClass, 'ai-search-mic') || null
				}),
				iconPosition === 'right' && _react2.default.createElement(
					_IconWrapper2.default,
					null,
					renderIcon()
				)
			),
			_react2.default.createElement(
				_IconGroup2.default,
				{ enableAI: true, groupPosition: 'left', positionType: 'absolute' },
				iconPosition === 'left' && _react2.default.createElement(
					_IconWrapper2.default,
					null,
					renderIcon()
				)
			)
		);
	};

	var onEnterButtonClick = function onEnterButtonClick(e) {
		handleSendMessage(e);
	};

	var renderEnterButtonFunc = function renderEnterButtonFunc() {
		var enterButton = props.enterButton,
		    renderEnterButton = props.renderEnterButton;

		if (enterButton) {
			var getEnterButtonMarkup = function getEnterButtonMarkup() {
				if (typeof renderEnterButton === 'function') {
					return renderEnterButton(onEnterButtonClick);
				}
				return _react2.default.createElement(
					_AIAnswer.SendButton,
					{
						primary: true,
						type: 'submit',
						tabIndex: 0,
						onClick: onEnterButtonClick,
						onKeyPress: handleKeyPress,
						className: 'enter-btn ' + (0, _helper.getClassName)(props.innerClass, 'ai-enter-button')
					},
					'Send'
				);
			};

			return _react2.default.createElement(
				'div',
				{ className: 'ai-enter-button-wrapper' },
				getEnterButtonMarkup()
			);
		}

		return null;
	};

	var getComponent = function getComponent() {
		var AIResponseError = props.AIResponseError,
		    isAIResponseLoading = props.isAIResponseLoading,
		    rawData = props.rawData;


		var data = {
			error: AIResponseError,
			loading: isAIResponseLoading,
			data: messages,
			rawData: rawData
		};
		return (0, _helper.getComponent)(data, props);
	};
	var handleRetryRequest = function handleRetryRequest() {
		if (messages) {
			var lastUserRequestMessage = messages[messages.length - 1] && messages[messages.length - 1].content;

			onSendMessage(lastUserRequestMessage, true);
		}
	};

	var renderErrorEle = function renderErrorEle() {
		var AIResponseError = props.AIResponseError,
		    renderError = props.renderError,
		    isAIResponseLoading = props.isAIResponseLoading;

		if (AIResponseError && !isAIResponseLoading) {
			if (renderError) {
				return _react2.default.createElement(
					'div',
					{
						className: '--ai-answer-error-container ' + ((0, _helper.getClassName)(props.innerClass, 'ai-error') || ''),
						ref: _errorWrapper
					},
					(0, _helper.isFunction)(renderError) ? renderError(AIResponseError, handleRetryRequest) : renderError
				);
			}
			return _react2.default.createElement(
				'div',
				{
					ref: _errorWrapper,
					className: '--ai-answer-error-container ' + ((0, _helper.getClassName)(props.innerClass, 'ai-error') || '')
				},
				_react2.default.createElement(
					'div',
					{ className: '--default-error-element' },
					_react2.default.createElement(
						'span',
						null,
						AIResponseError.message ? AIResponseError.message : 'There was an error in generating the response.',
						' ',
						AIResponseError.code ? 'Code:\n\t\t\t\t\t\t\t' + AIResponseError.code : ''
					),
					props.showRetryButton && _react2.default.createElement(
						_Button2.default,
						{ primary: true, onClick: handleRetryRequest },
						'Try again'
					)
				)
			);
		}
		return null;
	};

	var handleTextAreaHeightChange = function handleTextAreaHeightChange() {
		var textArea = _inputRef.current;
		if (textArea) {
			textArea.style.height = '42px';
			var lineHeight = parseInt(getComputedStyle(textArea).lineHeight, 10);
			var maxHeight = lineHeight * 11; // max height for 3 lines
			var height = Math.min(textArea.scrollHeight, maxHeight);
			textArea.style.height = height + 'px';
			textArea.style.overflowY = height === maxHeight ? 'auto' : 'hidden';
			// wrapper around input/ textarea
			_inputWrapper.current.style.height = height + 'px';

			if (_errorWrapper.current) {
				_errorWrapper.current.style.bottom = height + 'px';
			}
		}
	};
	var getAISourceObjects = function getAISourceObjects() {
		var sourceObjects = [];

		if (!props.AIResponse) return sourceObjects;
		var docIds = sourceDocIds || [];
		if (initialHits) {
			docIds.forEach(function (id) {
				var foundSourceObj = initialHits.find(function (hit) {
					return hit._id === id;
				}) || {};
				if (foundSourceObj) {
					var _foundSourceObj$_sour = foundSourceObj._source,
					    _source = _foundSourceObj$_sour === undefined ? {} : _foundSourceObj$_sour,
					    rest = _objectWithoutProperties(foundSourceObj, ['_source']);

					sourceObjects.push(_extends({}, rest, _source));
				}
			});
		} else {
			sourceObjects.push.apply(sourceObjects, docIds.map(function (id) {
				return {
					_id: id
				};
			}));
		}

		return sourceObjects;
	};

	var renderAIScreenFooter = function renderAIScreenFooter() {
		var _ref2 = props || {},
		    _ref2$showSourceDocum = _ref2.showSourceDocuments,
		    showSourceDocuments = _ref2$showSourceDocum === undefined ? true : _ref2$showSourceDocum,
		    _ref2$onSourceClick = _ref2.onSourceClick,
		    onSourceClick = _ref2$onSourceClick === undefined ? function () {} : _ref2$onSourceClick,
		    renderSourceDocument = _ref2.renderSourceDocument,
		    isAIResponseLoading = _ref2.isAIResponseLoading,
		    isAITyping = _ref2.isAITyping;

		if (isAIResponseLoading || isAITyping) {
			return null;
		}
		var renderSourceDocumentLabel = function renderSourceDocumentLabel(sourceObj) {
			if (renderSourceDocument) {
				return renderSourceDocument(sourceObj);
			}

			return sourceObj._id;
		};

		return showSourceDocuments && Array.isArray(sourceDocIds) && sourceDocIds.length ? _react2.default.createElement(
			_SearchBoxAI.Footer,
			{
				themePreset: props.themePreset,
				style: { marginTop: '1.5rem', background: 'inherit' }
			},
			'Summary generated using the following sources:',
			' ',
			_react2.default.createElement(
				_SearchBoxAI.SourceTags,
				null,
				getAISourceObjects().map(function (el) {
					return _react2.default.createElement(
						_Button2.default,
						{
							className: '--ai-source-tag ' + ((0, _helper.getClassName)(props.innerClass, 'ai-source-tag') || ''),
							info: true,
							onClick: function onClick() {
								return onSourceClick && onSourceClick(el);
							},
							key: el._id
						},
						renderSourceDocumentLabel(el)
					);
				})
			)
		) : null;
	};

	_react2.default.useEffect(function () {
		if (props.showSourceDocuments && props.AIResponse && props.AIResponse.response && props.AIResponse.response.answer && Array.isArray(props.AIResponse.response.answer.documentIds)) {
			setSourceDocIds(props.AIResponse.response.answer.documentIds);

			var localCache = (0, _helper.getObjectFromLocalStorage)(_constants.AI_LOCAL_CACHE_KEY) && (0, _helper.getObjectFromLocalStorage)(_constants.AI_LOCAL_CACHE_KEY)[props.componentId];
			if (localCache && localCache.meta && localCache.meta.hits && localCache.meta.hits.hits) {
				setInitialHits(localCache.meta.hits.hits);
			}
		}
	}, [props.AIResponse]);

	_react2.default.useEffect(function () {
		if (messagesContainerRef.current) {
			messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
		}
	}, [messages]);

	_react2.default.useEffect(function () {
		handleTextAreaHeightChange();
	}, [inputMessage]);

	_react2.default.useEffect(function () {
		if (props.rawData && props.rawData.hits && props.rawData.hits.hits) {
			setInitialHits(props.rawData.hits.hits);
		}
	}, [props.rawData]);

	return _react2.default.createElement(
		_AIAnswer.ChatContainer,
		{
			className: '--ai-chat-container',
			theme: props.theme,
			showInput: props.showInput
		},
		(0, _helper.hasCustomRenderer)(props) && getComponent(),
		!(0, _helper.hasCustomRenderer)(props) && _react2.default.createElement(
			_AIAnswer.MessagesContainer,
			{
				themePreset: props.themePreset,
				theme: props.theme,
				ref: messagesContainerRef,
				className: '--ai-messages-container'
			},
			messages.map(function (message, index) {
				return _react2.default.createElement(_AIAnswer.Message
				// eslint-disable-next-line react/no-array-index-key
				, { key: index,
					isSender: message.role === _constants.AI_ROLES.USER,
					dangerouslySetInnerHTML: {
						__html: md.render(message.content)
					},
					themePreset: props.themePreset,
					theme: props.theme,
					className: '--ai-answer-message ' + ((0, _helper.getClassName)(props.innerClass, 'ai-message') || '')
				});
			}),
			props.isAIResponseLoading && _react2.default.createElement(
				_AIAnswer.Message,
				{
					themePreset: props.themePreset,
					theme: props.theme,
					isSender: false,
					className: '--ai-answer-message ' + ((0, _helper.getClassName)(props.innerClass, 'ai-message') || null)
				},
				_react2.default.createElement(
					_AIAnswer.TypingIndicator,
					null,
					_react2.default.createElement(_AIAnswer.TypingDot, { themePreset: props.themePreset }),
					_react2.default.createElement(_AIAnswer.TypingDot, { themePreset: props.themePreset }),
					_react2.default.createElement(_AIAnswer.TypingDot, { themePreset: props.themePreset })
				)
			)
		),
		renderErrorEle(),
		props.showFeedback && !props.isAIResponseLoading && !props.isAITyping && _react2.default.createElement(
			'div',
			{
				className: '--ai-answer-feedback-container ' + ((0, _helper.getClassName)(props.innerClass, 'ai-feedback') || '')
			},
			_react2.default.createElement(_AIFeedback2.default, {
				hideUI: props.isAIResponseLoading || !props.currentSessionId,
				key: props.currentSessionId,
				onFeedbackSubmit: function onFeedbackSubmit(useful, reason) {
					props.trackUsefullness(props.currentSessionId, {
						useful: useful,
						reason: reason
					});
				}
			})
		),
		renderAIScreenFooter(),
		props.showInput && !props.isAIResponseLoading && !props.isAITyping && _react2.default.createElement(
			_AIAnswer.MessageInputContainer,
			{
				className: '--ai-input-container',
				onSubmit: handleSendMessage
			},
			_react2.default.createElement(
				_InputGroup2.default,
				{ isOpen: false },
				_react2.default.createElement(
					_InputWrapper2.default,
					{ ref: _inputWrapper, enableAI: true },
					_react2.default.createElement(_AIAnswer.MessageInput, {
						type: 'text',
						enterButton: props.enterButton,
						ref: _inputRef,
						placeholder: props.placeholder,
						value: inputMessage,
						onChange: handleMessageInputChange,
						onKeyPress: handleKeyPress,
						id: props.componentId + '-ai-input',
						showIcon: props.showIcon,
						iconPosition: props.iconPosition,
						themePreset: props.themePreset,
						className: (0, _helper.getClassName)(props.innerClass, 'ai-input') || null
					}),
					' ',
					renderIcons()
				)
			),
			renderEnterButtonFunc()
		),
		' '
	);
};

Chat.propTypes = {
	messages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		content: _propTypes2.default.string.isRequired,
		role: _propTypes2.default.string.isRequired
	})).isRequired,
	onSendMessage: _propTypes2.default.func.isRequired,
	componentId: _propTypes2.default.string.isRequired,
	showIcon: _propTypes2.default.bool,
	iconPosition: _types2.default.iconPosition,
	themePreset: _types2.default.themePreset,
	icon: _types2.default.children,
	iconURL: _types2.default.string,
	showVoiceInput: _types2.default.bool,
	renderMic: _types2.default.func,
	getMicInstance: _types2.default.func,
	innerClass: _types2.default.style,
	placeholder: _types2.default.string,
	AIResponse: _types2.default.componentObject,
	isAIResponseLoading: _types2.default.bool,
	AIResponseError: _types2.default.componentObject,
	enterButton: _types2.default.bool,
	renderEnterButton: _types2.default.title,
	showInput: _types2.default.bool,
	render: _types2.default.func,
	rawData: _types2.default.rawData,
	theme: _types2.default.style,
	renderError: _types2.default.title,
	showRetryButton: _types2.default.bool,
	showFeedback: _types2.default.bool,
	trackUsefullness: _types2.default.func,
	currentSessionId: _types2.default.string,
	showSourceDocuments: _types2.default.bool,
	renderTriggerMessage: _types2.default.children,
	renderSourceDocument: _types2.default.func,
	onSourceClick: _types2.default.func,
	isAITyping: _types2.default.boolRequired
};

exports.default = Chat;